import {
  DryRunResponse,
  ExecuteRunResponse,
  GroupingAgentGroup,
  GroupingAgentRun,
  GroupingAgentRunItem,
  InvocationType,
  OptionMappingReview,
  RunItemDetail,
  GroupEnrollmentsResponse,
  EnrollmentSourceDetail,
} from '@models/grouping-agent';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/grouping-agent';

export const listGroupingAgentRuns = async (params?: { date?: string; limit?: number }) => {
  return apiClient.get<GroupingAgentRun[]>(`${BASE_URL}/runs`, { params });
};

export const getGroupingAgentRun = async (runId: string) => {
  return apiClient.get<GroupingAgentRun>(`${BASE_URL}/runs/${runId}`);
};

export const getGroupingAgentRunItems = async (
  runId: string,
  params?: { refundRiskBand?: string; triggerBand?: string },
) => {
  return apiClient.get<GroupingAgentRunItem[]>(`${BASE_URL}/runs/${runId}/items`, { params });
};

export const getGroupingAgentRunItemDetail = async (runId: string, runItemId: string) => {
  return apiClient.get<RunItemDetail>(`${BASE_URL}/runs/${runId}/items/${runItemId}/detail`);
};

export const getGroupingAgentRunGroups = async (runId: string, params?: { groupStatus?: string }) => {
  return apiClient.get<GroupingAgentGroup[]>(`${BASE_URL}/runs/${runId}/groups`, { params });
};

export const getGroupingAgentGroupEnrollments = async (runId: string, groupId: string) => {
  return apiClient.get<GroupEnrollmentsResponse>(`${BASE_URL}/runs/${runId}/groups/${groupId}/enrollments`);
};

export const getGroupingAgentEnrollmentSource = async (scheduleId: string) => {
  return apiClient.get<EnrollmentSourceDetail>(`${BASE_URL}/enrollments/${scheduleId}/source`);
};

export const getGroupingAgentOptionMappingReviews = async (runId: string) => {
  return apiClient.get<OptionMappingReview[]>(`${BASE_URL}/runs/${runId}/option-mapping-reviews`);
};

export const resolveGroupingAgentOptionMapping = async (
  runId: string,
  reviewId: string,
  body: { action: 'approve' | 'skip'; resolvedOptionId?: string },
) => {
  return apiClient.post<OptionMappingReview>(
    `${BASE_URL}/runs/${runId}/option-mapping-reviews/${reviewId}/resolve`,
    body,
  );
};

export const runGroupingAgent = async (options?: {
  dryRun?: boolean;
  mode?: 'auto' | 'full' | 'incremental';
  invocationType?: InvocationType;
  force?: boolean;
}) => {
  const params: Record<string, string> = {};
  if (options?.dryRun) params.dryRun = 'true';
  if (options?.mode) params.mode = options.mode;
  if (options?.invocationType) params.invocationType = options.invocationType;
  if (options?.force) params.force = 'true';

  return apiClient.post<ExecuteRunResponse | DryRunResponse>(`${BASE_URL}/run`, {}, { params });
};
